import { Component, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { NoteUpd } from '../../models/NoteUpd';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CommonFunctions } from '../../static/common-functions';
import { Subscription } from 'rxjs';

@Component({
    selector: 'add-note',
    templateUrl: './add-note.component.html',
    styleUrls: ['./add-note.component.scss'],
    standalone: false
})
export class AddNoteComponent implements OnDestroy {

    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    constructor(protected featureFlagService: FeatureFlagService) {
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.usePrimeNg = this.featureFlagSet['use-primeng-inputs'];
        });
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }

    private _note: NoteUpd;
    notes: string = "";
    isPrintable: boolean = false;
    usePrimeNg: boolean;
    @Output() noteUpd: EventEmitter<NoteUpd> = new EventEmitter<NoteUpd>();
    @Input() active: boolean = false;
    //    @Input() note: NoteUpd = new NoteUpd();
    @Input() noteOnly: boolean = true;
    @Input() set note(noteUpd: NoteUpd) {
        if (noteUpd) {
            this._note = noteUpd;
            this.notes = noteUpd.notes;
            this.isPrintable = noteUpd.isPrintable;
        }
        else {
        }
    }
    @Input() noteTitle: string = "Add Note";
    get note(): NoteUpd {
        return this._note;
    }
    hide() {
        this.noteUpd.emit(null);
    }
    save() {
        let note: NoteUpd = new NoteUpd();
        note.isPrintable = this.isPrintable;
        note.notes = this.notes;
        this.noteUpd.emit(note);
    }
}

